<template>
    <div :style="getStyle" class="bg-white" id="jobsCreatedCard">
        <vx-card>
            <h2 class="mb-2">Derniers postes/stages créés</h2>
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <DialogPrompt
                        :active.sync="showPopup"
                        title="Consulter un poste/stage"
                        cancel-text="Fermer"
                        accept-text="Enregistrer"
                        button-accept="false"
                        @cancel="resetResource"
                        @close="resetResource"
                    >
                        <JobForm v-model="resource" type="show" />
                    </DialogPrompt>
                    <vs-table :sst="true" no-data-text="Aucune donnée à afficher" style="width: 100%" :data="jobs">
                        <template slot="thead">
                            <vs-th></vs-th>
                            <vs-th>Poste/Stage</vs-th>
                            <vs-th>Service</vs-th>
                            <vs-th>Etablissement</vs-th>
                            <vs-th>Créé le</vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <vs-tr v-for="(item, i) in jobs" :key="i" :data="item">
                                <vs-td>
                                    <feather-icon icon="ClipboardIcon" class="" />
                                </vs-td>
                                <vs-td
                                    v-tooltip="{
                                        content: item.description,
                                        placement: 'top-start',
                                        classes: ['occ-description'],
                                    }"
                                >
                                    <p @click="showResource(item)">{{ get(item, ":title") }}</p>
                                </vs-td>
                                <vs-td>
                                    <p @click="showResource(item)">{{ get(item, ":service.title") }}</p>
                                </vs-td>
                                <vs-td>
                                    <p @click="showResource(item)">{{ get(item, ":service.establishment.name") }}</p>
                                </vs-td>
                                <vs-td>
                                    <p @click="showResource(item)">{{ get(item, ":created_at") }}</p>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col class="text-right mt-2">
                    <a href="/rh/referentiel/postes">Voir plus...</a>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>
<script>
import JobForm from "@components/views/rh/referentiel/job/JobForm";
export default {
    components: {
        JobForm,
    },
    data() {
        return {
            jobs: "",
            showPopup: false,
            resource: {},
        };
    },
    computed: {
        getStyle() {
            return "height: 100%; background-size: contain; background-repeat: no-repeat; border: 2px solid #FCE4EC; border-radius: 5px; background-position: center;";
        },
    },
    created() {
        this.loadjobs();
    },
    methods: {
        showResource(resource) {
            this.resetResource();
            this.setResource(resource);
            this.showPopup = true;
        },
        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },
        resetResource() {
            this.resource = {
                title: null,
                description: null,
                sector: null,
                skills: {},
            };
        },
        loadjobs() {
            window
                .axios({
                    method: "get",
                    url: "/api/referentiel/jobs",
                    params: {
                        perpage: 4,
                        sortBy: { created_at: "desc" },
                        include: ["service.establishment", "occupation_skills.skills.admin_skill.category"],
                    },
                })
                .then((response) => {
                    response.data.data.forEach((element) => {
                        element["created_at"] = new Date(element["created_at"]).toLocaleString("fr-FR");
                    });

                    this.jobs = response.data.data;
                })
                .catch((err) => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },
    },
};
</script>
